import { IRabiesVaccination } from "../../../../services/medical-history/medical-history.interface";
import { SHORT_MONTHS_NAME } from "../../../../config/params";
import { getDaysUntil } from "../../../../utils/unix-timestamp";

export const EMPTY_VALUE = "—";

const formatShortDate = (epoch: number): string => {
  const date = new Date(epoch * 1000);

  return `${SHORT_MONTHS_NAME[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
};

export const formatDueSuffix = (daysUntil: number): string => {
  if (daysUntil === 0) {
    return "today";
  }
  if (daysUntil > 0) {
    return `in ${daysUntil} ${daysUntil === 1 ? "day" : "days"}`;
  }
  const overdue = Math.abs(daysUntil);

  return `overdue by ${overdue} ${overdue === 1 ? "day" : "days"}`;
};

export const formatGivenDate = (epoch?: number | null): string =>
  epoch ? formatShortDate(epoch) : EMPTY_VALUE;

export const formatDueDate = (epoch?: number | null, now?: Date): string =>
  epoch ?
    `${formatShortDate(epoch)} - ${formatDueSuffix(getDaysUntil(epoch, now))}` :
    EMPTY_VALUE;

export const sortByAdministeredDesc = (
  vaccinations: IRabiesVaccination[],
): IRabiesVaccination[] =>
  [...vaccinations].sort(
    (a, b) => (b.administeredAt ?? 0) - (a.administeredAt ?? 0),
  );
